// extracted by mini-css-extract-plugin
export var box = "Card-module__box___HamA6";
export var cardContainer = "Card-module__cardContainer___TWBSl";
export var content = "Card-module__content___fwXQ-";
export var description = "Card-module__description___Tb6G5";
export var icon = "Card-module__icon___N7GG+";
export var iconContainer = "Card-module__iconContainer___iEmyK";
export var lineIdAzure = "Card-module__lineIdAzure___vOWk+";
export var lineIdXbox = "Card-module__lineIdXbox___QtwND";
export var title = "Card-module__title___cswl3";